module.exports = __webpack_public_path__ + "e5efe01d3cd9864ccad8b58144c50916.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/main/m_tip.png
// module id = 185
// module chunks = 0